import { render, staticRenderFns } from "./LargeFilesConfiguration.vue?vue&type=template&id=49ebdc9a&"
import script from "./LargeFilesConfiguration.vue?vue&type=script&lang=ts&"
export * from "./LargeFilesConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports